import React, { useEffect, useState } from "react";
import { hot } from "react-hot-loader";
import { connect } from "dva";
import * as tc from "../../services/tc";
import { Select, Tag, Icon, Input, Modal, Spin } from "antd";
import TCTag from "../TestCase/elements/TCTag";
import { TestCasesApi } from "../../services/generated-sdk";
import { handleError } from "../../utils/common";
import { useStateValue } from "../TestCaseManage_aggrid/context";
import { hasPermission } from "../Roles/common";
import { AppContext } from "../../AppContext";
const Option = Select.Option;

function AddTagInput({ setTagTitle }) {
  return (
    <div>
      <Input
        placeholder="tag title"
        onChange={e => setTagTitle(e.target.value)}
      />
    </div>
  );
}

function TestCaseTagInputStatic({
  projectId,
  onChange,
  value,
  initialValue,
  style = {},
  tagsEnabled = true,
  disabled = false
}) {
  const { loggedInUser } = React.useContext(AppContext);
  const [tags, setTags] = useState([]);
  const { projectTags } = useStateValue();
  const [loading, setloading] = useState(false);
  let selectRef = React.createRef();
  const [showTagInput, setshowTagInput] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [showAddModal, setshowAddModal] = useState(false);
  const [newTagTitle, setNewTagTitle] = useState(false);
  const [tag, setTag] = useState("");

  const canManageTags = hasPermission(loggedInUser, "manageTags");

  const fetchTags = async () => {
    setloading(true);

    const API = new TestCasesApi();
    const data = await API.getTestCasesTags({ project: projectId });
    setTags(data);

    setloading(false);
    return data;
  };

  useEffect(
    () => {
      if (projectTags) setTags(projectTags);
      else fetchTags();
      setselectedTags(value && value.length > 0 ? value : initialValue);
    },
    [projectId, value, initialValue]
  );
  useEffect(() => {
    // return () => {
    //   window.removeEventListener('keydown');
    // };
  });

  // const onFocus = () => {
  //   selectRef.current.Select.addEventListener('keydown', e => {
  //     if (e.keyCode === 9) {
  //       addNewTag();
  //     }
  //   });
  // };

  // const onBlur = () => {
  //   window.removeEventListener('keydown');
  // };

  const addNewTag = async () => {
    if (tagsEnabled !== true || !canManageTags) {
      return;
    }
    if (tag) {
      selectRef.current.blur();
      setloading(true);
      // selectRef.current.focus();
      const API = new TestCasesApi();
      try {
        const data = await API.addTags({
          testCasesTagPayload: {
            project: projectId,
            name: tag
          }
        });

        await fetchTags();
        if (data && data.id) {
          const updatedTags =
            selectedTags != undefined ? [...selectedTags] : [];
          updatedTags.push(data.id);
          setselectedTags(updatedTags);
          onChange(updatedTags);
          setTag("");
        }

        setloading(false);
        //BLUR();
      } catch (e) {
        setloading(false);
        if (e.json) {
          e.json().then(data => {
            handleError(data.statusCode, {}, data.message || "");
          });
        } else {
          console.log({ tag_add_error: e });
          notification.warn({
            message:
              e && e.message
                ? e.message
                : "Could not add the tag at the moment. Please try again."
          });
        }
      }
      if (selectRef && selectRef.current) {
        selectRef.current.focus();
      }
    }

    // if (data) {
    //   // success message
    //   setshowAddModal(false);
    //   //onTagAdd()
    //   fetchTags();
    // }
  };

  if (!projectId) {
    return <span>Project ID not set!</span>;
  }

  const onSelectChange = opts => {
    setselectedTags(opts);
    onChange(opts);
  };

  return (
    <div>
      <Select
        loading={loading}
        filterOption={(input, option) => {
          setTag(input);
          if (option.key === "add") {
            setTag(input);
            return true;
          }
          return (
            typeof option.props.children == "string" &&
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
              0
          );
        }}
        // onBlur={onBlur}
        // onFocus={onFocus}
        ref={selectRef}
        onInputKeyDown={e => {
          if (!tags.length) {
            setTag(e.currentTarget.value);
          }
          if (e.keyCode === 9) {
            e.preventDefault();
            addNewTag();
          }
        }}
        placeholder={
          tagsEnabled === true
            ? "Select Tag or type to add a new Tag"
            : "To enable tags, upgrade to Premium"
        }
        // onChange={onChange}
        value={selectedTags}
        defaultValue={initialValue}
        onChange={onSelectChange}
        mode="multiple"
        //labelInValue={true}
        //showSearch={true}
        style={{ width: "100%", ...style }}
        disabled={tagsEnabled === true ? (disabled ? true : false) : true}
        getPopupContainer={trigger => trigger.parentNode}
      >
        {tags.map((tag, i) => (
          <Option
            value={tag.id}
            //value={tag.toString()}
            key={tag.id}
          >
            {tag.name}
          </Option>
        ))}

        {canManageTags && tag && tag.trim() ? (
          <Option value="add" key="add" disabled>
            <b>
              <a onClick={addNewTag}>Add a new tag</a>
            </b>
          </Option>
        ) : null}
      </Select>

      <Modal
        title="Add tag"
        okText="Add tag"
        visible={showAddModal && canManageTags}
        //visible={true}
        //footer={<span></span>}
        onOk={() => addNewTag(newTagTitle)}
        onCancel={() => setshowAddModal(false)}
      >
        <AddTagInput setTagTitle={val => setNewTagTitle(val)} />
      </Modal>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    // projectId: state.app.projectId
    //formLoading: state.loading.effects["app/login"]
  };
}

const TestCaseTagInput = connect(mapStateToProps)(TestCaseTagInputStatic);

export default hot(module)(TestCaseTagInput);
